import React from 'react';
import createReactClass from 'create-react-class';
import auth0 from '../../helpers/auth0';
import PropTypes from 'prop-types';

var NeedsClaim = createReactClass({
  propTypes: {
    claim: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.bool.isRequired,
    ])
  },

  render() {
    if(!this.props.claim || !auth0.hasClaim(this.props.claim)) {
      return null;
    }

    if(this.props.children.length > 1){
      return (<div>{this.props.children}</div>);
    }

    return this.props.children;
  }
});

export default NeedsClaim;



// WEBPACK FOOTER //
// ./src/components/common/NeedsClaim.js